export default __webpack_public_path__ + "static/logo-db3d9833828aa7f16ad571586b7dc8f7.svg";